export default __webpack_public_path__ + "static/media/f4.d7a5a35a.png";